export type MemberStage = "funded" | "challenge" | "verification" | "new";

export interface DashboardMember {
  id: string;
  name: string;
  shortName: string;
  size: string;
  sizeK: number;
  stage: MemberStage;
  pnl: number;
  dd: number;
  avatar_url: string | null;
  road: number;
  roadTarget: number;
  account_number: string;
  sl: number;
  journal: number;
  avColor: string;
  avBg: string;
  passScore: number;
  losses: number;
  totalTrades: number;
  healthStatus?: string;
  alerts?: string[];
  platform?: string;
}


export type NotificationLevel = "urgent" | "warning" | "success" | "info";

export interface DashboardNotification {
  id: string;
  level: NotificationLevel;
  member: string;
  title: string;
  body: string;
  createdAt: string; // ISO date
  read: boolean;
}

export interface DashboardSummary {
  totalMembers: number;
  growing: number;
  danger: number;
  funded: number;
  passable: number;
  monthlyLosses: number;
  slViolations: number;
  missingJournal: number;
}

export const dashboardSummary: DashboardSummary = {
  totalMembers: 10,
  growing: 6,
  danger: 2,
  funded: 3,
  passable: 4,
  monthlyLosses: 38,
  slViolations: 9,
  missingJournal: 4,
};

export const stageDistribution = [
  { label: "Funded", value: 3, color: "#2D7A3A" },
  { label: "Challenge", value: 5, color: "#1A5FA8" },
  { label: "Verification", value: 1, color: "#5B3FA8" },
  { label: "Mới", value: 1, color: "#9B9589" },
];
